module.exports = {
      id: "illustrations:NZ01-usage",
      viewBox: "0 0 468.7 345.3",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:NZ01-usage",
      toString: function () {
        return this.url;
      }
    }